import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDealBrief } from '@/api/calls';
import { useToast } from '@/store/toast';

/**
 * «Открыть сделку» из звонка, итога или задачи календаря.
 * Отдельного экрана сделки пока нет: сделка открывается в своей переписке, сразу с окном сделки
 * (`?sheet=deal`). Сделка без переписки — объясняем словами.
 */
export function useOpenDeal() {
  const navigate = useNavigate();
  const toast = useToast((t) => t.show);
  return useCallback(async (dealId: string | null | undefined) => {
    if (!dealId) { toast('Звонок не привязан к сделке'); return; }
    try {
      const d = await getDealBrief(dealId);
      if (d.chatwootAccountId && d.chatwootDisplayId) {
        navigate(`/inbox/${d.chatwootAccountId}/${d.chatwootDisplayId}?sheet=deal`);
      } else {
        toast('У сделки нет переписки — карточка сделки откроется в «Воронке», когда она появится', 3200);
      }
    } catch (e) {
      toast(e instanceof Error ? e.message : 'Не удалось открыть сделку');
    }
  }, [navigate, toast]);
}
